<template>
<div class="chapter">
<div class="inner_page">
<p class="p4">To Victor J. Banis, <br/>front-line pioneer of gay fiction and a master storyteller, whose scope of work—with its emotional depth, imagination, and quality—is likely to remain unsurpassed for a very, very long time.</p>
<p class="p0">Thank you for being such a generous mentor.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 004.vue?7ed92fb0